import { UUID } from 'crypto';
import { mapStowagePlanChange } from './StowagePlanChanges/StowagePlanChangeFactory';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';

export const filterAndMapOfflineStowagePlanChanges = (offlineStowagePlans: any[], imoNumber: number, stowagePlanGuid: UUID): StowagePlanChange[] => {
    if (!offlineStowagePlans?.length) {
        return [];
    }

    // Step 1: Filter stowage plans by IMO number and ensure they have saveStowageDataRequest
    const stowagePlansWithMatchingImo = offlineStowagePlans.filter((plan) => {
        const imoMatches = +plan.imoNumber === +imoNumber;
        const hasStowageDataRequest = Boolean(plan.saveStowageDataRequest);
        return imoMatches && hasStowageDataRequest;
    });

    // Step 2: Process each plan's saveStowageDataRequest
    const result: StowagePlanChange[] = [];
    for (const plan of stowagePlansWithMatchingImo) {
        // Step 3: Process each request in the plan
        for (const request of plan.saveStowageDataRequest) {
            // Step 4: Process each body in the request
            if (!request.body) {
                continue;
            }

            for (const body of request.body) {
                // Step 5: Map the body to stowage plan changes
                const mappedChange = mapStowagePlanChange(body);

                const guidMatches = mappedChange.stowagePlanGuid === stowagePlanGuid;

                if (guidMatches) {
                    result.push(mappedChange);
                }
            }
        }
    }

    return result;
};
